/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function OrbitIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="orbit"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M17.487 5.515A8.5 8.5 0 1 1 9.466 3.893" data-tinysvg-shape="arc" data-tinysvg-arc="12 12.006 8.5 8.5 310.209 252.658 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={12} cy={12} r={4} stroke={color} fill="none" data-stroke-tone="primary" />
          <circle cx={12} cy={3.5} r={2} stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
